import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { faBookOpenReader, faMagnifyingGlass, faFilter, faCalendarDays, faEye } from "@fortawesome/free-solid-svg-icons";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PulseLoader } from "react-spinners";
import ModalRapor from './modal/rapor';
import ModalTglRapor from "./modal/cetak_tanggal_rapor_teacher";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  .shimmer {
    animation: shimmer 1.2s linear infinite forwards;
    background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );
    background-size: 800px 104px;
  }
`;



export default function Dimensi() {
  document.title = "Rapor";

  const [savingId, setSavingId] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const storageTeacher = localStorage.getItem('teacherID');
  const storageBranch = localStorage.getItem('ysb_branch_id');
  
  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  // Table data
  const [getData, setGetData] = useState([]);
  const [getDataKop, setGetDataKop] = useState([]);
  const [showModalTanggal, setShowModalTanggal] = useState(false);

  // Search (frontend)
  const [searchKeyword, setSearchKeyword] = useState("");

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  // EDIT nilai
  const [form3, setForm3] = useState({
    ysb_element_recap_id_id: "",
    ysb_sub_element_value: "",
  });

  const [updateId, setUpdateID] = useState(null);
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // =========================
  // INIT: Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes, dimensiRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Dimensi aktif pertama
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
        if (dims.length > 0) setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0].id }));
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
        setLoading(false);       // ⬅️ shimmer BARU MATI DI SINI
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);


  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty && !!form2.ysb_semester_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_dimensi_id
  ) return;

  const params = {

     ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          branch: storageBranch,
        //   ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: storageSchoolId,
          ysb_teacher_id: storageTeacher
  };

  try {
    const response = await APILA.get(
      "/api/rapot-teacher/teacher",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
      setGetDataKop(response.data.data_kop || []);
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);


  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD: tampilkan table otomatis setelah default filter lengkap
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ HANYA SEKALI
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (!form2.ysb_semester_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setSearchKeyword("");
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };


  // const [showModal, setShowModal] = useState(false);
  // const [selectedRapor, setSelectedRapor] = useState(null);
  // const [dataKopRapor, setdataKopRapor] = useState(null);
  

  // const viewModalRapor = (id, rapor) => {
  //   try {
  //     setSelectedRapor(rapor || null);
  //     setShowModal(true);
  //     setdataKopRapor(getDataKop);
  //   } catch (err) {
  //     console.error('viewModalRapor error', err);
  //   }
  // }

  const [showModal, setShowModal] = useState(false);
  const [selectedRapor, setSelectedRapor] = useState(null);
  const [dataKopRapor, setdataKopRapor] = useState(null);

  const viewModalRapor = (id, rapor) => {
    try {
      // tutup dulu sebentar agar modal tidak membawa state murid sebelumnya
      setShowModal(false);

      setTimeout(() => {
        setSelectedRapor(rapor || null);
        setdataKopRapor(getDataKop || null);
        setShowModal(true);
      }, 0);
    } catch (err) {
      console.error("viewModalRapor error", err);
    }
  };

  const handleCloseModalRapor = () => {
    setShowModal(false);
    setSelectedRapor(null);
    setdataKopRapor(null);
  };

  // =========================
  // SEARCH FILTER (frontend)
  // =========================
  // const filteredData = useMemo(() => {
  //   const q = (searchKeyword || "").trim().toLowerCase();
  //   if (!q) return getData;

  //   return (getData || []).filter((item) => {
  //     const name = (item?.name_student || "").toString().toLowerCase();
  //     const nisn = (item?.nisn || "").toString().toLowerCase();
  //     return name.includes(q) || nisn.includes(q);
  //   });
  // }, [getData, searchKeyword]);
  // =========================
// SEARCH + SORT (frontend)
// - search: nama / NISN
// - sort : nama siswa A -> Z
// =========================
  // const filteredData = useMemo(() => {
  //   const q = (searchKeyword || "").trim().toLowerCase();

  //   const base = q
  //     ? (getData || []).filter((item) => {
  //         const name = (item?.name_student || "").toString().toLowerCase();
  //         const nisn = (item?.nisn || "").toString().toLowerCase();
  //         return name.includes(q) || nisn.includes(q);
  //       })
  //     : (getData || []);

  //   // ✅ Urutkan nama siswa A -> Z (case-insensitive)
  //   return [...base].sort((a, b) => {
  //     const an = (a?.name_student || "").toString().trim();
  //     const bn = (b?.name_student || "").toString().trim();

  //     const cmpName = an.localeCompare(bn, "id", { sensitivity: "base" });
  //     if (cmpName !== 0) return cmpName;

  //     // Tie-breaker biar stabil (kalau nama sama)
  //     const aNisn = (a?.nisn || "").toString();
  //     const bNisn = (b?.nisn || "").toString();
  //     return aNisn.localeCompare(bNisn, "id", { numeric: true, sensitivity: "base" });
  //   });
  // }, [getData, searchKeyword]);

  const filteredData = useMemo(() => {
    const q = (searchKeyword || "").trim().toLowerCase();

    const base = q
      ? (getData || []).filter((item) => {
          const name = (item?.name_student || "").toString().toLowerCase();
          const nisn = (item?.nisn || "").toString().toLowerCase();
          return name.includes(q) || nisn.includes(q);
        })
      : (getData || []);

    return [...base].sort((a, b) => {
      const orderA =
        a?.order_absen === null ||
        a?.order_absen === undefined ||
        a?.order_absen === ""
          ? null
          : Number(a.order_absen);

      const orderB =
        b?.order_absen === null ||
        b?.order_absen === undefined ||
        b?.order_absen === ""
          ? null
          : Number(b.order_absen);

      const aIsNew = orderA !== null && !Number.isNaN(orderA);
      const bIsNew = orderB !== null && !Number.isNaN(orderB);

      if (!aIsNew && bIsNew) return -1;
      if (aIsNew && !bIsNew) return 1;

      if (aIsNew && bIsNew) {
        if (orderA !== orderB) return orderA - orderB;

        const an = (a?.name_student || "").toString().trim();
        const bn = (b?.name_student || "").toString().trim();

        const cmpName = an.localeCompare(bn, "id", { sensitivity: "base" });
        if (cmpName !== 0) return cmpName;

        const aNisn = (a?.nisn || "").toString();
        const bNisn = (b?.nisn || "").toString();
        return aNisn.localeCompare(bNisn, "id", {
          numeric: true,
          sensitivity: "base",
        });
      }

      const an = (a?.name_student || "").toString().trim();
      const bn = (b?.name_student || "").toString().trim();

      const cmpName = an.localeCompare(bn, "id", { sensitivity: "base" });
      if (cmpName !== 0) return cmpName;

      const aNisn = (a?.nisn || "").toString();
      const bNisn = (b?.nisn || "").toString();
      return aNisn.localeCompare(bNisn, "id", {
        numeric: true,
        sensitivity: "base",
      });
    });
  }, [getData, searchKeyword]);

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  const viewModalTanggal = () => {
    setShowModalTanggal(true);
  };



   return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body rapor-page">
        {showModalTanggal && (
          <ModalTglRapor
            show={showModalTanggal}
            onHide={() => setShowModalTanggal(false)}
            selectedSemesterId={form2.ysb_semester_id}
            selectedSemesterName={
              getDataSemesterMap.find(
                (item) => String(item?.id) === String(form2.ysb_semester_id)
              )?.name_year || namaTA
            }
            selectedSemesterNumber={
              getDataSemesterMap.find(
                (item) => String(item?.id) === String(form2.ysb_semester_id)
              )?.semester || namaSmstr
            }
            branch={storageBranch}
            level={storageLevel}
            schoolId={storageSchoolId}
          />
        )}

        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faBookOpenReader} />
              </span>
              <h4 className="page-title-text">Rapor</h4>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-teacher">Beranda</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li className="custom-breadcrumb-item active" aria-current="page">
                Rapor
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content rapor-content mt-2">
          {/* <div className="rapor-filter-card">
            <div className="rapor-filter-header">
              <div className="rapor-filter-title-wrap">
                <span className="rapor-filter-icon">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <div>
                  <h5 className="rapor-filter-title">Filter Rapor</h5>
                  <p className="rapor-filter-subtitle">
                    Pilih semester untuk menampilkan daftar rapor siswa.
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={viewModalTanggal}
                className="rapor-print-button"
              >
                <FontAwesomeIcon icon={faCalendarDays} />
                <span>Cetak Tanggal Rapor</span>
              </button>
            </div>

            {loading ? (
              <div className="rapor-filter-grid rapor-filter-grid-teacher">
                {Array.from({ length: 2 }).map((_, index) => (
                  <div className="rapor-filter-field" key={index}>
                    <div className="shimmer rapor-filter-shimmer-label" />
                    <div className="shimmer rapor-filter-shimmer-control" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="rapor-filter-grid rapor-filter-grid-teacher">
                <div className="rapor-filter-field">
                  <label className="rapor-filter-label">Tahun Ajaran / Semester</label>
                  <select
                    className="rapor-filter-select"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((item, index) => (
                      <option key={index} value={item?.id}>
                        {item?.name_year} (Semester {item?.semester})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="rapor-filter-field rapor-filter-action">
                  <button
                    type="button"
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="rapor-filter-button"
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    Cari Data
                  </button>
                </div>
              </div>
            )}
          </div> */}

          <div className="rapor-filter-card">
  <div className="rapor-filter-toolbar">
    <div className="rapor-filter-list">
      <div className="rapor-filter-item">
        <label>Semester</label>
        <select
          name="ysb_semester_id"
          value={form2.ysb_semester_id}
          onChange={handleChange}
          className="rapor-filter-select"
        >
          <option value="" hidden>
            {namaTA} (Semester {namaSmstr})
          </option>

          {getDataSemesterMap.map((user, index) => (
            <option key={index} value={user?.id}>
              {user?.name_year} (Semester {user?.semester})
            </option>
          ))}
        </select>
      </div>

      <div className="rapor-filter-action">
        <button
          type="button"
          onClick={handleCari}
          disabled={!isFilterComplete}
          className="rapor-btn-search"
        >
          Cari
        </button>
      </div>
    </div>

    {/* PALING KANAN */}
    <div className="rapor-print-action">
      <button
        type="button"
        onClick={viewModalTanggal}
        className="rapor-btn-print"
      >
       <FontAwesomeIcon icon={faCalendarDays} />
                <span>Cetak Tanggal Rapor</span>
      </button>
    </div>
  </div>
</div>

          {isFetching && (
            <div className="rapor-loading">
              <PulseLoader color="#3f5bea" size={11} />
            </div>
          )}

          {hasSearched && !isFetching && (
            <>
              <div className="rapor-search-wrap">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="rapor-search-icon"
                />
                <input
                  className="rapor-search-input"
                  placeholder="Cari nama siswa atau NISN..."
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </div>

              <div className="rapor-table-card">
                <div className="rapor-table-scroll">
                  <table className="rapor-table">
                    <thead>
                      <tr>
                        <th className="rapor-col-number">No</th>
                        <th className="rapor-col-name">Nama Siswa</th>
                        <th className="rapor-col-nisn">NISN</th>
                        <th className="rapor-col-action">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length === 0 ? (
                        <tr>
                          <td colSpan={4} className="rapor-empty-state">
                            Data tidak ditemukan
                          </td>
                        </tr>
                      ) : (
                        filteredData.map((rapor, index) => (
                          <tr key={rapor?.ysb_student_id || rapor?.id || index}>
                            <td className="rapor-col-number">
                              <span className="rapor-number-badge">
                                {(page - 1) * 10 + (index + 1)}
                              </span>
                            </td>
                            <td className="rapor-col-name">
                              <span className="rapor-student-name">
                                {toTitleCase(rapor?.name_student)}
                              </span>
                            </td>
                            <td className="rapor-col-nisn">
                              <span className="rapor-nisn-text">
                                {rapor?.nisn || "-"}
                              </span>
                            </td>
                            <td className="rapor-col-action">
                              <button
                                type="button"
                                className="rapor-view-button"
                                onClick={() =>
                                  viewModalRapor(
                                    rapor?.ysb_student_id || rapor?.id,
                                    rapor
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faEye} />
                                <span>Lihat Rapor</span>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {selectedRapor && (
            <ModalRapor
              key={selectedRapor?.ysb_student_id || selectedRapor?.id}
              show={showModal}
              onHide={handleCloseModalRapor}
              data_rapor={selectedRapor}
              data_kop={dataKopRapor}
              id_student={selectedRapor?.ysb_student_id || selectedRapor?.id}
              getData={getData}
            />
          )}
        </div>
      </div>
    </>
  );
}
